<template>
  <div class="mt-4">
    <div class="text-left readers-list">
      <sdui-waterfall-search v-model="readerGroups"
                             class="p-0 outer-list"
                             :url="url"
      >
        <!-- Questions list -->
        <template v-if="readerGroups.length">
          <li v-for="(question, index) in survey.questions"
              :key="`readers-group-${question.uuid}`"
              data-cy="survey-question-list"
          >
            <SList class="question-list mt-4">
              <template #title>
                <span class="question-title mb-2" data-test="answered-survey-question">{{ index + 1 }}: {{ question.question }}*</span>
              </template>
              <!-- Options per question list -->
              <li
                v-for="(group, optionUuid) in groupUsersByQuestionAndOption(question.uuid)"
                :key="`readers-group-${optionUuid}`"
                data-cy="option-list"
              >
                <SList class="options-list mt-2">
                  <template #title>
                    <div>
                      <span class="option-title gray-450 mb-2 text-muted d-block" data-test="answered-survey-option">
                        {{ optionPropToShow(optionUuid, question.uuid, 'name') }}
                        <span v-if="!isQuestionTypeFreetext(question)" class="sr-only">{{ $t('survey.voting.votes') }}</span>
                        <span v-if="!isQuestionTypeFreetext(question)"
                              aria-hidden="true"
                              data-cy="count-indicator"
                        >•</span>
                        {{ optionPropToShow(optionUuid, question.uuid, 'count') }}
                      </span>
                    </div>
                  </template>
                  <!-- Users per selected option -->
                  <sdui-user-list-item
                    v-for="(reader, i) in groupUsersByOption[optionUuid]"
                    :key="`reader-${i}`"
                    :user="new User(reader.user)"
                    :prevent-hover="true"
                  >
                    <template #action>
                      <span />
                    </template>
                  </sdui-user-list-item>
                </SList>
              </li>
            </SList>
          </li>
        </template>
      </sdui-waterfall-search>
    </div>
  </div>
</template>

<script>
import SduiWaterfallSearch from 'src/components/miscellaneous/ui/common/SduiWaterfallSearch.vue'
import SduiUserListItem from 'src/components/user/SduiUserListItem.vue'
import { User } from 'src/store/models/index.js'
import Channels from 'src/api/channels.js'
import surveyMixin from 'src/mixins/channels/survey/surveyMixin.js'

export default {
  name: 'SduiMultiQuestionSurveyVotersList',
  components: { SduiUserListItem, SduiWaterfallSearch },
  mixins: [surveyMixin],
  props: {
    survey: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    readerGroups: [],
    User: User,
  }),

  computed: {
    url() {
      return `${Channels.channelSurveyResultsAnsweredByIdUrl(this.survey.id, true)}&`
    },

    groupUsersByOption() {
      return this.groupBy(this.readerGroups, 'option_uuid')
    },
  },

  methods: {
    groupBy(items, key) {
      return items.reduce(
        (result, item) => ({
          ...result,
          [item[key]]: [...(result[item[key]] || []), item],
        }),
        {},
      )
    },

    // Prevents unnecessary(empty list) renders of the options list
    groupUsersByQuestionAndOption(questionUuid) {
      const filterReaderGroupsByQuestion = this.readerGroups.filter((group) => group.question_uuid === questionUuid)
      return this.groupBy(filterReaderGroupsByQuestion, 'option_uuid')
    },

    optionPropToShow(optionUuid, questionUuid, prop) {
      const options = this.survey.questions.find((q) => q.uuid === questionUuid).options
      if (!options.find((o) => o.uuid === optionUuid)) return false
      return options?.find((o) => o.uuid === optionUuid)[prop]
    },
  },
}
</script>

<style scoped lang="scss">
.outer-list :deep(.sdui-list__list) {
  border: none;
  box-shadow: none;
}
:deep(.sdui-user-item) {
  box-shadow: $sdui-shadow;
  border-radius: 8px;
  border: 1px solid $color-gray-100;
}
.question-title {
  font-size: pxtorem(17);
  font-weight: $font-weight-normal;
}
.option-title {
  font-size: pxtorem(15);
  font-weight: 450;
}
</style>
